export default __webpack_public_path__ + "static/media/checkmark.2af8d8a6.svg";